export const QUESTION_MAPPING = (homeDelivery = false, hasPreviousReservationDate) => ({
  firstName: {
    section: 3,
    question: 0,
    answerType: "answerValue",
    behaviour: "value-only",
    box: 0,
  },
  lastName: {
    section: 3,
    question: 1,
    answerType: "answerValue",
    behaviour: "value-only",
    box: 0,
  },
  mail: {
    section: 3,
    question: 3,
    answerType: "answerValue",
    box: 0,
  },
  phone: {
    section: 3,
    question: 2,
    answerType: "answerValue",
    box: 0,
  },
  ...(homeDelivery
    ? {
        recipient: {
          section: 7,
          question: 0,
          answerType: "answerValue",
          box: 1,
          requestField: "destinatario",
        },
        address: {
          section: 7,
          question: 1,
          answerType: "answerValue",
          box: 1,
          requestField: "indirizzo",
        },
        streetnumber: {
          section: 7,
          question: 2,
          answerType: "answerValue",
          box: 1,
          requestField: "numeroCivico",
        },
        postcode: {
          section: 7,
          question: 3,
          answerType: "answerValue",
          box: 1,
          requestField: "cap",
        },
        city: {
          section: 7,
          question: 4,
          answerType: "answerValue",
          box: 1,
          requestField: "città",
        },
        province: {
          section: 7,
          question: 5,
          answerType: "answerValue",
          box: 1,
          requestField: "provincia",
        },
      }
    : {
        at: {
          section: 4,
          question: 0,
          answerType: "answerValue",
          behaviour: "distribution-point",
          box: 1,
        },
        day: {
          answerType: "date",
          behaviour: "value-only",
          format: "dddd",
          box: 2,
          requestField: "reservationStart",
        },
        date: {
          answerType: "date",
          behaviour: "value-only",
          format: "LL",
          box: 2,
          requestField: "reservationStart",
        },
        time: {
          answerType: "date",
          format: "HH:mm",
          box: 2,
          requestField: "reservationStart",
        },
      }),
});

export const getQuestionLabel = (questionId, labels) => {
  return labels?.[`WELFARE_CART_SURVEY_${questionId.toUpperCase()}`] || questionId;
};
